angular.module('unica_invitation_list.invitation_list_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// INVITATION LIST
		.state('app.invitation_list', {
			url: '/invitation-list',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/invitation-list/templates/invitation-list.html',
					controller: 'InvitationListBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// INVITATION LIST LIST
			.state('app.invitation_list.list', {
				url: '/list/:event_id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/list.html',
						controller: 'InvitationListListController'
					}
				},
				ncyBreadcrumb: {
					label: 'Tipologie Liste',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			})

			// INVITATION LIST CREATE
			.state('app.invitation_list.create', {
				url: '/create/:event_id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/create.html',
						controller: 'InvitationListCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Crea Tipologia Lista',
					parent: 'app.invitation_list.list'
				}
			})

			// INVITATION LIST EDIT
			.state('app.invitation_list.edit', {
				url: '/edit/:event_id/:id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/edit.html',
						controller: 'InvitationListEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Tipologia Lista',
					parent: 'app.invitation_list.list'
				}
			})

			// INVITATION LIST COMUNICATION
			.state('app.invitation_list.comunicate', {
				url: '/comunicate/:event_id/:id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/comunicate.html',
						controller: 'InvitationListComunicateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Comunicazione',
					parent: function($scope) {
						return 'app.invitation.list({event_id:' + $scope.event_id + ', invitation_list_id: ' + $scope.id + '})';
					}
				}
			})

			// INVITATION LIST COMUNICATION DEM
			.state('app.invitation_list.comunicate_dem', {
				url: '/comunicate/dem/:event_id/:id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/comunicate-dem.html',
						controller: 'InvitationListComunicateDemController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Personalizza Email di Invito',
					parent: function($scope) {
						return 'app.invitation_list.comunicate({ event_id: ' + $scope.event_id + ', id:' + $scope.id + '})';
					}
				}
			})

			// INVITATION LIST COMUNICATION DEM CONFIRMATION
			.state('app.invitation_list.comunicate_dem_confirmation', {
				url: '/comunicate/dem-confirmation/:event_id/:id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/comunicate-dem-confirmation.html',
						controller: 'InvitationListComunicateDemConfirmationController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Personalizza Email di Conferma',
					parent: function($scope) {
						return 'app.invitation_list.comunicate({ event_id:' + $scope.event_id + ', id:' + $scope.id + '})';
					}
				}
			})

			// INVITATION LIST COMUNICATION DEM DECLINED
			.state('app.invitation_list.comunicate_dem_declined', {
				url: '/comunicate/dem-declined/:event_id/:id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/comunicate-dem-declined.html',
						controller: 'InvitationListComunicateDemDeclinedController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Personalizza Email di non Partecipazione',
					parent: function($scope) {
						return 'app.invitation_list.comunicate({ event_id:' + $scope.event_id + ', id:' + $scope.id + '})';
					}
				}
			})

			// INVITATION LIST COMUNICATION BADGE
			.state('app.invitation_list.comunicate_badge', {
				url: '/comunicate/badge/:event_id/:id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/comunicate-badge.html',
						controller: 'InvitationListComunicateBadgeController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Personalizza Badge',
					parent: function($scope) {
						return 'app.invitation_list.comunicate({ event_id:' + $scope.event_id + ', id:' + $scope.id + '})';
					}
				}
			})

			// INVITATION LIST ICS
			.state('app.invitation_list.comunicate_ics', {
				url: '/comunicate/ics/:event_id/:id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/comunicate-ics.html',
						controller: 'InvitationListComunicateIcsController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Personalizza ICS',
					parent: function($scope) {
						return 'app.invitation_list.comunicate({ event_id:' + $scope.event_id + ', id:' + $scope.id + '})';
					}
				}
			})


			// APPROVATION LIST DEM ZM
			.state('app.invitation_list.comunicate_dem_al_zm', {
				url: '/comunicate/dem-approvation-list-zm/:event_id/:id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/comunicate-dem-al-zm.html',
						controller: 'InvitationListComunicateDemALZmController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Personalizza Email ZM',
					parent: function($scope) {
						return 'app.invitation_list.comunicate({ event_id:' + $scope.event_id + ', id:' + $scope.id + '})';
					}
				}
			})

			// APPROVATION LIST DEM AM
			.state('app.invitation_list.comunicate_dem_al_am', {
				url: '/comunicate/dem-approvation-list-am/:event_id/:id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/comunicate-dem-al-am.html',
						controller: 'InvitationListComunicateDemALAmController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Personalizza Email AM',
					parent: function($scope) {
						return 'app.invitation_list.comunicate({ event_id:' + $scope.event_id + ', id:' + $scope.id + '})';
					}
				}
			})

			// APPROVATION LIST DEM ZM CONFIRM
			.state('app.invitation_list.comunicate_dem_al_zm_confirmation', {
				url: '/comunicate/dem-approvation-list-zm-confirm/:event_id/:id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/comunicate-dem-al-zm-confirm.html',
						controller: 'InvitationListComunicateDemALZmConfirmController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Personalizza Email ZM di Conferma',
					parent: function($scope) {
						return 'app.invitation_list.comunicate({ event_id:' + $scope.event_id + ', id:' + $scope.id + '})';
					}
				}
			})



			// GRAND PRIX COMUNICATION
			.state('app.invitation_list.comunicate_gp', {
				url: '/comunicate-gp/:event_id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/comunicate-gp.html',
						controller: 'InvitationListComunicateGPController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Comunicazione Grand Prix',
					parent: function($scope) {
						return 'app.invitation_list.list({event_id:' + $scope.event_id + '})';
					}
				}
			})


			// GRAND PRIX TEMPLATE PRE-INVITO
			.state('app.invitation_list.comunicate_gp_preinvitation', {
				url: '/comunicate/gp-preinvitation/:event_id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/comunicate-gp-preinvitation.html',
						controller: 'InvitationListComunicateGPPreinvitationController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Personalizza Email Pre-Invito GP',
					parent: function($scope) {
						return 'app.invitation_list.comunicate_gp({ event_id:' + $scope.event_id + '})';
					}
				}
			})

			// GRAND PRIX TEMPLATE APPROVED
			.state('app.invitation_list.comunicate_gp_approved', {
				url: '/comunicate/gp-approved/:event_id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/comunicate-gp-approved.html',
						controller: 'InvitationListComunicateGPApprovedController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Personalizza Email Approvazione GP',
					parent: function($scope) {
						return 'app.invitation_list.comunicate_gp({ event_id:' + $scope.event_id + '})';
					}
				}
			})

			// GRAND PRIX TEMPLATE DECLINED
			.state('app.invitation_list.comunicate_gp_declined', {
				url: '/comunicate/gp-declined/:event_id',
				views: {
					'invitationListContent': {
						templateUrl: './modules/invitation-list/templates/comunicate-gp-declined.html',
						controller: 'InvitationListComunicateGPDeclinedController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Personalizza Email Rifiuto GP',
					parent: function($scope) {
						return 'app.invitation_list.comunicate_gp({ event_id:' + $scope.event_id + '})';
					}
				}
			})






	;


});

